/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */
/* eslint-disable @atlaskit/design-system/prefer-primitives */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */

import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { SecondaryNavWrapper } from './SecondaryNavWrapper';
export var SecondaryNav = function SecondaryNav() {
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Image, null));
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var Wrapper = styled(SecondaryNavWrapper)({
  borderRight: '24px solid #fff'
});
var Image = function Image() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "240",
    height: "775",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5F7",
    d: "M0 0h240v775H0z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SecondaryNavA)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M26 88h24v24H26z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    x: "22",
    y: "84",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "71",
    height: "8",
    x: "66",
    y: "96",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    x: "22",
    y: "124",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "71",
    height: "8",
    x: "66",
    y: "136",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M26 168h24v24H26z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    x: "22",
    y: "164",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "71",
    height: "8",
    x: "66",
    y: "176",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "208",
    height: "40",
    x: "16",
    y: "200",
    fill: "#091E42",
    fillOpacity: ".04",
    rx: "3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: ".01",
    d: "M26 208h24v24H26z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    x: "22",
    y: "204",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "71",
    height: "8",
    x: "66",
    y: "216",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    x: "22",
    y: "244",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "71",
    height: "8",
    x: "66",
    y: "256",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    x: "22",
    y: "284",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "71",
    height: "8",
    x: "66",
    y: "296",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  })), /*#__PURE__*/React.createElement("rect", {
    width: "120",
    height: "12",
    x: "74",
    y: "38",
    fill: "#091E42",
    fillOpacity: ".13",
    rx: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "40",
    height: "40",
    x: "18",
    y: "24",
    fill: "#DEEBFF",
    rx: "3"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SecondaryNavA"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 80h208v240H16z"
  }))));
};